var map = {
	"./bill1.png": 2432,
	"./bill2.png": 2283,
	"./bill3.png": 1154,
	"./bill4.png": 7501,
	"./bill5.png": 6372,
	"./bill6.png": 7660,
	"./bill7.png": 6262,
	"./billieselogo.png": 9318,
	"./cowallet1.webp": 1834,
	"./cowallet2.webp": 8683,
	"./cowallet3.webp": 2232,
	"./cowallet4.webp": 801,
	"./cowallet5.webp": 7174,
	"./cowallet6.webp": 4551,
	"./cowallet7.webp": 1540,
	"./cowallet8.webp": 7597,
	"./cowalletlogo.png": 1206,
	"./edu1.webp": 3407,
	"./edu2.webp": 6254,
	"./edu3.webp": 7145,
	"./edu4.webp": 8000,
	"./edu5.webp": 5491,
	"./edu6.webp": 8066,
	"./edu7.webp": 1085,
	"./edumpusbanner.png": 3473,
	"./edumpusmobile.png": 1445,
	"./fly1.webp": 7616,
	"./fly2.webp": 2285,
	"./fly3.webp": 7346,
	"./fly4.webp": 6895,
	"./flytalklogo.png": 5844,
	"./lucky1.png": 2195,
	"./lucky2.png": 5336,
	"./lucky3.png": 9201,
	"./lucky4.png": 2462,
	"./lucky5.png": 4951,
	"./lucky6.png": 5948,
	"./lucky7.png": 8213,
	"./luckyhandbanner.png": 7693,
	"./luckyhandlogo.png": 2754,
	"./maziplay.png": 313,
	"./naif1.webp": 2229,
	"./naif2.webp": 7832,
	"./naif3.webp": 651,
	"./naif4.webp": 8646,
	"./naif5.webp": 3377,
	"./naifmeat.png": 5681,
	"./test.png": 8370,
	"./zlopes1.jpg": 448,
	"./zlopes2.jpg": 5407,
	"./zlopes3.jpg": 5410,
	"./zlopes4.jpg": 1969,
	"./zlopes5.jpg": 3444,
	"./zlopesbanner.png": 2743,
	"./zlopesmobile.png": 5763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 452;